import React from 'react';
import { useLocalization } from 'src/utils/useLocalization';

interface ICheckboxProps {
    name: string;
    value: string;
    onCheck: (evt: any) => void;
    checked: boolean;
    isError?: boolean;
    ErrorMessage?: string;
    allBlack?: boolean;
    disabled?: boolean;
    html?: string;
}

export const Checkbox: React.FC<ICheckboxProps> = ({
    name,
    value,
    onCheck,
    checked,
    isError = false,
    ErrorMessage,
    allBlack = false,
    disabled = false,
    html,
}) => {
    const { labelField } = useLocalization();
    const onChangeHandler = (event: any) => {
        if (event.currentTarget.checked) {
            onCheck(true);
        } else {
            onCheck(false);
        }
    };

    return (
        <>
            <label className='c-checkbox'>
                <input
                    className={`c-checkbox__input ${isError ? 'is-error' : ''}`}
                    type='checkbox'
                    value={value}
                    onChange={onChangeHandler}
                    checked={checked}
                    disabled={disabled}
                />
                <span
                    className={`c-checkbox__label ${
                        allBlack ? 'all-black' : ''
                    }`}
                    dangerouslySetInnerHTML={
                        html ? { __html: html } : undefined
                    }
                >
                    {html ? undefined : name}
                </span>
            </label>
            {isError ? (
                <p className='c-error-message'>
                    {ErrorMessage
                        ? ErrorMessage
                        : labelField.LABEL_FIELD_ERROR_REQUIRED}
                </p>
            ) : null}
        </>
    );
};
